var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseTabRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 2,
    fill: "#F3F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53033 6.46967C7.23744 6.17678 6.76256 6.17678 6.46967 6.46967C6.17678 6.76256 6.17678 7.23744 6.46967 7.53033L7.53033 6.46967ZM14.4697 15.5303C14.7626 15.8232 15.2374 15.8232 15.5303 15.5303C15.8232 15.2374 15.8232 14.7626 15.5303 14.4697L14.4697 15.5303ZM6.46967 7.53033L14.4697 15.5303L15.5303 14.4697L7.53033 6.46967L6.46967 7.53033Z",
    fill: "#E66666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46967 14.4697C6.17678 14.7626 6.17678 15.2374 6.46967 15.5303C6.76256 15.8232 7.23744 15.8232 7.53033 15.5303L6.46967 14.4697ZM15.5303 7.53033C15.8232 7.23744 15.8232 6.76256 15.5303 6.46967C15.2374 6.17678 14.7626 6.17678 14.4697 6.46967L15.5303 7.53033ZM7.53033 15.5303L15.5303 7.53033L14.4697 6.46967L6.46967 14.4697L7.53033 15.5303Z",
    fill: "#E66666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseTabRed);
export default __webpack_public_path__ + "static/media/CloseTab-red.f76f06d6d1f84ee579327b99d4fcd68f.svg";
export { ForwardRef as ReactComponent };